"use strict";

exports.__esModule = true;
exports.default = null;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/lib/prod/patch.prod.js
// module id = 116
// module chunks = 0